import { Injectable } from '@angular/core';

@Injectable()
export class SessionService {

    organizationID: number;
    tenantID: number;
    userID: number;
    roles: number[];
    baseURL: String;
    actionUrl: String;
    envString:String;
    /**
     * Used for passing objects from one object to another
     */
    object: any;

    constructor() {
        // this.baseURL ="https://localhost:8443/SurveyServices"; //Test Code
        // this.baseURL ="https://192.168.2.166:8443/SurveyServices"; //Test Code
        // this.setUrls();
    }

    setUrls(finalUrl:string){
        // if(this.envString=="prod"){
        //     this.baseURL ="https://altservices.peoplestrong.com/SurveyServices";
        // }else if(this.envString=="sohum"){
        //     this.baseURL ="https://altservices.sohum.com/SurveyServices";
        // }else if(this.envString=="uat"){
        //     this.baseURL ="https://uat-altservices.peoplestrong.com/SurveyServices";
        // }else if(this.envString=="staging"){
        //     this.baseURL ="https://staging-altservices.peoplestrong.com/SurveyServices";
        // }else if(this.envString=="local"){
        //     this.baseURL ="https://altservices.sohum.com/SurveyServices"; //Test Code 
        // }
        this.baseURL =finalUrl;
    }
}
